import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { useLocation } from 'react-router-dom';

import MainHome from "./MainPortal/Homepage/MainHome";
import Orders from "./MainPortal/Orders/Orders";
import Explore from "./MainPortal/Explore/Explore";
import DetailedListing from './MainPortal/ListingPage/DetailedListing.js';
import Authenticating from './MainPortal/Common/Authenticating.js';
import Messages from "./MainPortal/Messages/Messages";
import LoadingVendors from './VendorPortal/Loading/LoadingVendors.js';
import VendorHome from "./VendorPortal/Homepage/VendorHome";
import VendorLogin from "./VendorPortal/Login/VendorLogin";
import VendorValidate from "./VendorPortal/Login/VendorValidate";
import VendorProfile from "./VendorPortal/Profile/VendorProfile";
import VendorLoginRequired from "./VendorPortal/Login/VendorLoginRequired";
import VendorAlreadyLoggedIn from "./VendorPortal/Login/VendorAlreadyLoggedIn";
import ProfileDetails from "./VendorPortal/Profile/Components/ProfileDetails/ProfileDetails";

import AdminHome from "./AdminPortal/Homepage/AdminHome";
import AdminProfile from "./AdminPortal/Profile/AdminProfile";
import AdminLogin from "./AdminPortal/Login/AdminLogin";
import AdminLoginRequired from "./AdminPortal/Login/AdminLoginRequired";

import LinkDoesNotExist from "./Common/LinkDoesNotExist";
import TermsOfService from "./Common/TermsOfService";
import { useUser } from './UserContext';
import awsAppSyncConfig from './aws-config.js';
import awsmobile from './cognito-config.js';
import { useEffect } from 'react';
import LeaveReview from './MainPortal/Explore/Components/LeaveReview';
import Signup from './VendorPortal/SignUp/Signup';
import AddListing from './VendorPortal/Profile/Components/Listings/AddEditListing.js';
import LogRocket from 'logrocket';


LogRocket.init('0uhgus/charmhealthhub', {
  dom: {
    isEnabled: true
  },
  network: {
    isEnabled: true
  },
  session: {
    trackInteractions: true,
    recordCanvas: true,
  },
  console: {
    isEnabled: true
  }
});

function App() {

  // This is used everywhere. Cognito will not work without this. But you don't have to keep calling this everywhere.
  useEffect(() => {
    const amplifyEnvironment = {
      ...awsmobile,
      ...awsAppSyncConfig,
    };
    Amplify.configure(amplifyEnvironment);
  }, []);

  const { isSignedIn, setIsSignedIn } = useUser();


  function ExploreWithDynamicId() {
    const location = useLocation();
    const id = location.pathname.split("/").pop(); // Extract the "id" from the URL

    // Check if `id` is a number
    const isNumeric = /^[0-9]+$/.test(id);

    // Redirect if `id` is not a number
    if (!isNumeric) {
      return <Navigate to="/error" replace />; // Redirect to an error page or fallback
    }
    return <DetailedListing id={id} />;
  }

  return (

    <Routes>
      <Route path="/" element={<MainHome />} />
      <Route path="/authenticating/*" element={<Authenticating />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/reviews" element={<LeaveReview />} />
      {/* <Route path="/explore/all" element={<Explore page="all" />} /> */}
      <Route path="/explore/essentials" element={<Explore page="essentials" />} />
      <Route path="/explore/custom" element={<Explore page="custom" />} />
      <Route path="/explore/category/popular" element={<Explore page="popular" />} />
      <Route path="/explore/category/billers" element={<Explore page="billers" />} />
      <Route path="/explore/category/billing-tools" element={<Explore page="billing-tools" />} />
      <Route path="/explore/category/consultants" element={<Explore page="consultants" />} />
      <Route path="/explore/category/crms" element={<Explore page="crms" />} />
      <Route path="/explore/category/developers" element={<Explore page="developers" />} />
      <Route path="/explore/category/devices" element={<Explore page="devices" />} />
      <Route path="/explore/category/health-information-exchange" element={<Explore page="health-information-exchange" />} />
      <Route path="/explore/category/marketing" element={<Explore page="marketing" />} />
      <Route path="/explore/category/patient-engagement" element={<Explore page="patient-engagement" />} />
      <Route path="/explore/category/remote-patient-monitoring" element={<Explore page="remote-patient-monitoring" />} />
      <Route path="/explore/category/supplement-dispensary" element={<Explore page="supplement-dispensary" />} />
      <Route path="/explore/category/transcription" element={<Explore page="transcription" />} />
      <Route path="/explore/category/tech-led-innovations" element={<Explore page="tech-led-innovations" />} />
      <Route path="/explore/category/venture-capital-%2F-incubator" element={<Explore page="venture-capital-incubator" />} />
      <Route path="/explore/category/workflow-&-productivity" element={<Explore page="workflow-productivity" />} />
      <Route path="/explore/category/all" element={<Explore page="all" />} />
      <Route path="/explore/*" element={<ExploreWithDynamicId />} />
      <Route path="/vendors" element={<VendorHome />} />
      <Route path="/vendors/signup" element={<Signup />} />
      <Route path="/vendors/login" element={isSignedIn ? <VendorAlreadyLoggedIn /> : <VendorLogin />} />
      <Route path="/vendors/validatePage" element={<VendorValidate />} />
      <Route path="/vendors/profile" element={isSignedIn ? <VendorProfile /> : <VendorLoginRequired />} />
      <Route path="/vendors/unapproved" element={isSignedIn ? <VendorProfile category={"UNAPPROVED"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/rejected" element={isSignedIn ? <VendorProfile category={"REJECTED"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/deactivated" element={isSignedIn ? <VendorProfile category={"DEACTIVATED"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/error" element={isSignedIn ? <VendorProfile category={"UNEXPECTEDERROR"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/profile/dashboard" element={isSignedIn ? <VendorProfile category={"Dashboard"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/profile/listings" element={isSignedIn ? <VendorProfile category={"Listings"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/profile/orders" element={isSignedIn ? <VendorProfile category={"Orders"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/profile/reviews" element={isSignedIn ? <VendorProfile category={"Reviews"} /> : <VendorLoginRequired />} />
      {/* <Route path="/vendors/profile/documents"
        element={isSignedIn ? <VendorProfile category={"Documents"} /> : <VendorLoginRequired />} /> */}
      {/* <Route path="/vendors/profile/api-program"
        element={isSignedIn ? <VendorProfile category={"API Program"} /> : <VendorLoginRequired />} /> */}
      {/* <Route path="/vendors/profile/messages"
        element={isSignedIn ? <VendorProfile category={"Messages"} /> : <VendorLoginRequired />} /> */}
      <Route path="/vendors/profile/invite-teammate" element={isSignedIn ? <VendorProfile category={"Users"} /> : <VendorLoginRequired />} />
      <Route path="/vendors/profile/self" element={isSignedIn ? <ProfileDetails /> : <VendorLoginRequired />} />
      <Route path="/vendors/edit/:id" element={isSignedIn ? <AddListing editMode={true} /> : <VendorLoginRequired />} />
      <Route path="/admins" element={<AdminHome />} />
      <Route path="/admins/login" element={<AdminLogin />} />
      {/* <Route path="/admins/profile/vendors" element={isSignedIn ? <AdminProfile /> : <AdminLoginRequired />}/>
      <Route path="/admins/profile/products" element={isSignedIn ? <AdminProfile /> : <AdminLoginRequired />}/>
      <Route path="/admins/profile/orders" element={isSignedIn ? <AdminProfile /> : <AdminLoginRequired />}/>
      <Route path="/admins/profile/messages" element={isSignedIn ? <AdminProfile /> : <AdminLoginRequired />}/> */}
      <Route path="/admins/profile/*" element={isSignedIn ? <AdminProfile /> : <AdminLoginRequired />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/404" element={<LinkDoesNotExist />} />
      <Route path="/vendors/loading" element={<LoadingVendors />} />
      <Route path="*" element={<MainHome />} />
    </Routes>

  );
}

export default App;